export const blacklistTableTitles: {[key: string]: string} = {
  pan: 'Card PAN',
  status: 'Status',
  date: 'Date blacklisted',
} 

export const blacklistTableData = [
  { pan: '**** **** **** 1234', status: 'one@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'two@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'three@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'four@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'five@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'six@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'seven@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'eight@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'nine@mail.com', date: 'Aug 13, 2020 2:21PM', },
  { pan: '**** **** **** 1234', status: 'ten@mail.com', date: 'Aug 13, 2020 2:21PM', }
];